export default {
  section: 'Market Map',
  config: {
    standalone: true,
    title: 'Create new map',
  },
};
